<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.alefcafe.com\/storage\/content\/pat2.png\");\n\n"' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.alefcafe.com\/storage\/content\/2.png","alt":"\u06a9\u0627\u0641\u0647 \u0627\u0644\u0641"},...{}}' :style='"height: 300px;\nobject-fit: contain;"' class="col-12 " ></m-img><m-div v-bind='{...{},...{}}' :style='""' class="mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-products-302 v-bind='{...{"paginate":false,"perPage":35,"productCardName":"mProductCard302","showSpecifiedCardFeature":""},...{}}' :style='""' class="container mb-5 pb-5" ></m-products-302></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mProducts302 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products302/Products302';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mProducts302 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
